<template>
  <nav class="navbar navbar-vertical fixed-left navbar-expand-md navbar-light"
    :class="{ 'theme-dark': themeState.isDarkMode }"
    id="sidenav-main"
    v-if="accessDetails">
    <div class="container-fluid">
      <!--Toggler-->
      <navbar-toggle-button @click.native="showSidebar" class="mobile-hamburger" />
      <div class="mobile-toolbar">
        <router-link class="navbar-brand sidebar-brand" to="/" aria-label="SchoolDock dashboard">
          <img class="navbar-brand-img" v-if="schlogo" :src="schlogo" alt="" />
          <img v-else class="navbar-brand-img" alt="" :src="logo" />
          <span class="sidebar-brand-name">SchoolDock</span>
        </router-link>

        <div class="mobile-toolbar-actions">
          <button class="theme-toggle" type="button" @click="toggleTheme" :title="themeState.isDarkMode ? 'Switch to light mode' : 'Switch to dark mode'">
            <i :class="themeState.isDarkMode ? 'fa fa-sun' : 'fa fa-moon'"></i>
          </button>
          <base-dropdown class="mobile-profile-menu" position="right" v-if="accessDetails">
            <a slot="title" class="mobile-profile-trigger" href="#" role="button" aria-label="Open profile menu" @click.prevent>
              <img v-if="accessDetails.passportPath" :src="accessDetails.passportPath" alt="" />
              <img v-else src="/img/brand/loguser.png" alt="" />
            </a>
            <div class="dropdown-header noti-title">
              <h6 class="text-overflow m-0">Welcome! <span class="ml-1">{{ accessDetails.fullName }}</span></h6>
            </div>
            <div class="dropdown-divider"></div>
            <router-link to="/user-profile" class="dropdown-item">
              <i class="fa fa-user"></i><span>Profile</span>
            </router-link>
            <div class="dropdown-divider"></div>
            <button type="button" class="dropdown-item" @click="logout">
              <i class="fa fa-right-from-bracket"></i><span>Logout</span>
            </button>
          </base-dropdown>
        </div>
      </div>
      <slot></slot>
      <div
        v-if="$sidebar.showSidebar"
        class="sidebar-mobile-backdrop"
        aria-hidden="true"
        @click="closeSidebar"
      ></div>
      <div v-show="$sidebar.showSidebar" class="navbar-collapse collapse show sidebar-mobile-panel" id="sidenav-collapse-main">
        <div class="navbar-collapse-header d-md-none">
          <div class="row">
            <div class="col-6 collapse-brand">
              <router-link to="/">
                <img v-if="schlogo" :src="schlogo" alt="" />
                <img v-else alt="" :src="logo" />
              </router-link>
            </div>
            <div class="col-6 collapse-close">
              <navbar-toggle-button class="sidebar-close-button" @click.native="closeSidebar" aria-label="Close navigation">
                <span class="sidebar-close-icon" aria-hidden="true"></span>
              </navbar-toggle-button>
            </div>
          </div>
        </div>

        <div class="sidebar-menu-group">
          <div class="sidebar-menu-title">Main Menu</div>
          <ul class="navbar-nav">
            <slot name="links"> </slot>
          </ul>
        </div>
      </div>
    </div>
  </nav>
</template>

<script>
import NavbarToggleButton from "@/components/NavbarToggleButton";

export default {
  name: "sidebar",
  components: {
    NavbarToggleButton
  },
  props: {
    logo: {
      type: String,
      default: "/img/brand/green.png",
      description: "Sidebar app logo"
    },
    autoClose: {
      type: Boolean,
      default: true,
      description:
        "Whether sidebar should autoclose on mobile when clicking an item"
    }
  },
  data() {
    return {
      accessDetails: null,
      currentterm: {},
      userinfo: {},
      newsItem: null,
      schlogo: "",
      ExpiredDate: "",
      smsbalance: null,
      onloader: "none"
    };
  },
  provide() {
    return {
      autoClose: this.autoClose
    };
  },
  inject: {
    themeState: {
      default: {
        isDarkMode: false
      }
    },
    toggleTheme: {
      default: () => {}
    }
  },

  methods: {
    getcurrentterm() {
      this.accessDetails = this.$store.getters['auth/_user'];
      if (this.accessDetails.isSchoolStudent == true || this.accessDetails.isStudentGuardian == true || this.accessDetails.isSchoolStaff == true) {
        this.onloader = "flex";
        this.$store
          .dispatch("getcurrentterm")
          .then(resp => {
            this.currentterm = resp;
            this.schlogo = resp.Logo;
            if (resp.Logo == null) {
              this.schlogo = 'img/brand/empty.png';
            }
            this.onloader = "none";
          })
          .catch(err => {
            console.log(err);
            this.onloader = "none";
          });
      }
    },
    logout() {
      this.$store.dispatch("auth/Logout").then(() => {
        this.$router.push("/login");
      });
    },
    closeSidebar() {
      this.$sidebar.displaySidebar(false);
    },
    showSidebar() {
      this.$sidebar.displaySidebar(true);
    }
  },
  beforeDestroy() {
    if (this.$sidebar.showSidebar) {
      this.$sidebar.showSidebar = false;
    }
  },
  mounted() {
    this.getcurrentterm();
  }
};
</script>

<style scoped>
.navbar-vertical {
  background-color: var(--sidebar-bg) !important;
  border-right: 1px solid var(--app-border);
  box-shadow: 0 1px 2px var(--app-shadow);
}

.navbar-vertical.theme-dark {
  background-color: var(--sidebar-bg) !important;
}

.navbar-collapse,
.navbar-collapse-header,
.sidebar-mobile-panel {
  background-color: var(--sidebar-bg) !important;
}

.sidebar-mobile-panel {
  padding: 0.7rem 0 1.25rem;
}

.sidebar-mobile-backdrop {
  display: none;
}

@media (max-width: 767.98px) {
  .navbar-vertical {
    position: relative;
    z-index: 1041;
  }

  .sidebar-mobile-backdrop {
    display: block;
    position: fixed;
    z-index: 1042;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    background: rgba(15, 23, 42, 0.48);
    backdrop-filter: blur(3px);
    animation: sidebar-backdrop-enter 180ms ease-out both;
  }

  .sidebar-mobile-panel {
    position: fixed;
    z-index: 1043;
    top: 0;
    bottom: 0;
    left: 0;
    width: min(22rem, 88vw);
    max-height: 100vh;
    max-height: 100dvh;
    margin: 0 !important;
    padding: 0.75rem 0 1.25rem;
    overflow-y: auto;
    overscroll-behavior: contain;
    -webkit-overflow-scrolling: touch;
    scrollbar-width: thin;
    border: 0 !important;
    border-radius: 0 1.15rem 1.15rem 0;
    box-shadow: 1rem 0 3rem rgba(15, 23, 42, 0.24) !important;
    animation: sidebar-drawer-enter 260ms cubic-bezier(0.2, 0.75, 0.25, 1) both;
  }

  .navbar-collapse.sidebar-mobile-panel.show,
  .navbar-collapse.sidebar-mobile-panel.collapsing {
    background: var(--sidebar-bg) !important;
    color: var(--sidebar-text-strong) !important;
    border: 0;
  }

  ::v-deep .sidebar-mobile-panel .navbar-nav .nav-link {
    color: var(--sidebar-text) !important;
  }

  ::v-deep .sidebar-mobile-panel .navbar-nav .nav-link:hover,
  ::v-deep .sidebar-mobile-panel .navbar-nav .nav-link:focus,
  ::v-deep .sidebar-mobile-panel .navbar-nav .nav-link.active {
    color: var(--sidebar-active-text) !important;
    background: var(--sidebar-hover-bg) !important;
  }

  ::v-deep .sidebar-mobile-panel .navbar-collapse-header {
    border-bottom-color: var(--app-border) !important;
  }

  ::v-deep .sidebar-mobile-panel .navbar-nav {
    gap: 0.3rem;
    padding: 0 1rem 0.75rem;
  }

  ::v-deep .sidebar-mobile-panel .collapse-brand {
    display: flex;
    align-items: center;
    padding-left: 1.15rem;
  }

  ::v-deep .sidebar-mobile-panel .collapse-brand img {
    width: 2rem;
    height: 2rem;
    max-width: 2rem;
    max-height: 2rem;
    object-fit: contain;
  }

  ::v-deep .sidebar-mobile-panel .navbar-collapse-header {
    min-height: 3.75rem;
    margin: 0 0 0.7rem;
    padding: 0 0.65rem 0.7rem;
    border-bottom: 1px solid var(--app-border);
  }

  .sidebar-menu-group {
    margin-top: 0;
  }

  .sidebar-menu-title {
    margin: 1rem 1.2rem 0.7rem;
    font-size: 0.68rem;
    letter-spacing: 0.12em;
  }
}

@keyframes sidebar-drawer-enter {
  from { opacity: 0.7; transform: translateX(-1.25rem); }
  to { opacity: 1; transform: translateX(0); }
}

@keyframes sidebar-backdrop-enter {
  from { opacity: 0; }
  to { opacity: 1; }
}

@media (prefers-reduced-motion: reduce) {
  .sidebar-mobile-panel,
  .sidebar-mobile-backdrop {
    animation: none !important;
  }
}

.mobile-toolbar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 0.6rem;
  width: 100%;
  min-height: 4.5rem;
  padding: 0.75rem 0.7rem;
  border-bottom: 1px solid var(--app-border);
}

@media (max-width: 380px) {
  .mobile-toolbar {
    gap: 0.35rem;
    padding-right: 0.45rem;
    padding-left: 0.45rem;
  }

  .mobile-toolbar .navbar-brand {
    max-width: 8.5rem;
  }

  .sidebar-brand-name {
    font-size: 0.84rem;
  }
}

.mobile-toolbar .navbar-brand {
  display: inline-flex;
  align-items: center;
  gap: 0.55rem;
  max-width: 11rem;
  padding: 0;
}

.mobile-toolbar .navbar-brand-img {
  width: 2rem;
  height: 2rem;
  max-width: 2rem;
  max-height: 2rem;
  object-fit: contain;
}

.sidebar-brand-name {
  overflow: hidden;
  color: var(--sidebar-text-strong);
  font-size: 0.94rem;
  font-weight: 700;
  letter-spacing: 0;
  line-height: 1;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.mobile-toolbar-actions {
  display: flex;
  align-items: center;
  gap: 0.45rem;
  margin-left: auto;
}

.mobile-profile-menu {
  position: relative;
  display: inline-flex;
  align-items: center;
}

@media (min-width: 768px) {
  .mobile-profile-menu {
    display: none !important;
  }
}

.mobile-profile-trigger {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 2.25rem;
  height: 2.25rem;
  overflow: hidden;
  border: 1px solid var(--app-border);
  border-radius: 50%;
  background: var(--sidebar-hover-bg);
  box-shadow: 0 2px 7px rgba(15, 23, 42, 0.12);
  transition: transform 160ms ease, box-shadow 160ms ease;
}

.mobile-profile-trigger:hover,
.mobile-profile-trigger:focus-visible {
  transform: translateY(-1px);
  box-shadow: 0 4px 10px rgba(15, 23, 42, 0.18);
  outline: 2px solid var(--sidebar-active-text);
  outline-offset: 2px;
}

.mobile-profile-trigger img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

::v-deep .mobile-profile-menu .dropdown-menu {
  right: 0 !important;
  left: auto !important;
  min-width: min(16rem, calc(100vw - 1rem));
  margin-top: 0.55rem;
  border: 1px solid var(--app-border);
  border-radius: 0.8rem;
  box-shadow: 0 1rem 2rem var(--app-shadow);
}

::v-deep .mobile-profile-menu .dropdown-item {
  display: flex;
  align-items: center;
  gap: 0.65rem;
  min-height: 2.7rem;
}

.mobile-hamburger {
  color: var(--sidebar-active-text) !important;
}

.mobile-hamburger .navbar-toggler-icon {
  background-image: none;
  color: var(--sidebar-active-text) !important;
}

.mobile-hamburger .navbar-toggler-icon::before,
.mobile-hamburger .navbar-toggler-icon::after {
  background-color: var(--sidebar-active-text) !important;
}

.sidebar-close-icon {
  position: relative;
  display: inline-block;
  width: 1.15rem;
  height: 1.15rem;
  color: var(--sidebar-active-text);
  transition: transform 0.2s ease;
}

.sidebar-close-icon::before,
.sidebar-close-icon::after {
  content: '';
  position: absolute;
  top: 50%;
  left: 50%;
  width: 1.2rem;
  height: 2px;
  border-radius: 2px;
  background: currentColor;
}

.sidebar-close-icon::before {
  transform: translate(-50%, -50%) rotate(45deg);
}

.sidebar-close-icon::after {
  transform: translate(-50%, -50%) rotate(-45deg);
}

.sidebar-close-button {
  transition: transform 0.2s ease, background-color 0.2s ease;
}

.sidebar-close-button:hover,
.sidebar-close-button:focus-visible {
  transform: scale(1.08);
  background: var(--sidebar-hover-bg);
}

.sidebar-close-button:hover .sidebar-close-icon,
.sidebar-close-button:focus-visible .sidebar-close-icon {
  transform: rotate(90deg);
}

.sidebar-mobile-panel.show .sidebar-close-button {
  animation: close-button-enter 0.3s ease both;
}

@keyframes close-button-enter {
  from {
    opacity: 0;
    transform: rotate(-45deg) scale(0.7);
  }

  to {
    opacity: 1;
    transform: rotate(0) scale(1);
  }
}

@media (prefers-reduced-motion: reduce) {
  .sidebar-close-button,
  .sidebar-close-icon {
    animation: none;
    transition: none;
  }
}

.theme-toggle {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 2.1rem;
  height: 2.1rem;
  border: 1px solid var(--app-border);
  border-radius: 0.45rem;
  background: transparent;
  color: var(--sidebar-text);
  transition: background-color 0.2s ease, color 0.2s ease;
}

.theme-toggle i {
  color: var(--sidebar-active-text);
}

.theme-toggle:hover {
  background: var(--sidebar-hover-bg);
  color: var(--sidebar-text-strong);
}

.sidebar-menu-group {
  margin-top: 0.2rem;
}

.sidebar-menu-title {
  margin: 0.85rem 0.9rem 0.45rem;
  font-size: 0.61rem;
  font-weight: 700;
  letter-spacing: 0.1em;
  text-transform: uppercase;
  color: var(--app-muted);
}

.navbar-nav {
  padding: 0 0.7rem;
}

@media (min-width: 768px) {
  .mobile-toolbar {
    margin: 0 -0.8rem;
    width: calc(100% + 1.6rem);
    padding-right: 1.5rem;
    padding-left: 1.5rem;
  }
}
</style>
